var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCallbackTimeOffset(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66675 1.33398H9.33341",
    stroke: "#7B7B7B",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.33268V6.66602",
    stroke: "#7B7B7B",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66675 8.66683C2.82999 7.37081 3.46319 6.17977 4.44625 5.31959C5.42931 4.45941 6.69386 3.98992 8.00008 4.00016C8.86278 4.00108 9.71238 4.21126 10.476 4.61267C11.2396 5.01408 11.8945 5.59474 12.3844 6.30485C12.8743 7.01495 13.1846 7.83329 13.2887 8.68968C13.3929 9.54607 13.2877 10.4149 12.9823 11.2218C12.6768 12.0286 12.1803 12.7493 11.5351 13.322C10.8899 13.8947 10.1155 14.3024 9.27812 14.51C8.44079 14.7177 7.56558 14.7191 6.72757 14.5142C5.88956 14.3093 5.11377 13.9041 4.46675 13.3335L2.66675 11.7335",
    stroke: "#7B7B7B",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00008 11.334H2.66675V14.6673",
    stroke: "#7B7B7B",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallbackTimeOffset);
export default __webpack_public_path__ + "static/media/callback-time-offset.e981efb12b8fbea038895a36d1858884.svg";
export { ForwardRef as ReactComponent };